module.exports = __webpack_public_path__ + "img/bgreport.145e1cd6.jpg";